var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.classes,style:({cursor: _vm.cursor}),on:{"click":_vm.handleClick}},[(_vm.title)?_c('title',{domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_c('use',{attrs:{"xlink:href":_vm.iconPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }